module.exports = __webpack_public_path__ + "img/nikolaev.53566618.png";